<div class="columns">
  <div class="column">
    <iss-form-field>
      <iss-label>{{ 'iss-wo-common.recurrence-schedule.date-range.start-date' | translate }}</iss-label>
      <tui-input-date
        data-e2e="repetitive service start date field"
        woNativeDate
        [formControl]="startDate"
        [min]="minStart | tuiDay"
        [readOnly]="!!readonly"
        [tuiTextfieldLabelOutside]="true"
        (ngModelChange)="adjustMinEnd()"
      >{{ 'iss-wo-common.recurrence-schedule.date-range.start-date' | translate }}</tui-input-date>
      <ng-template issFormFieldError let-errors>
        <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
        <ng-container *ngIf="errors.minDate">{{ 'iss-wo-common.error.min-date' | translate: { minDate: errors.minDate | date }
        }}</ng-container>
      </ng-template>
    </iss-form-field>
  </div>
  <div class="column">
    <iss-form-field>
      <iss-label>{{ 'iss-wo-common.recurrence-schedule.date-range.end-date' | translate }}</iss-label>
      <tui-input-date
        data-e2e="repetitive service end date field"
        woNativeDate
        [formControl]="endDate"
        [minDate]="minEnd | tuiDay"
        [readOnly]="!!readonly"
        [tuiTextfieldLabelOutside]="true"
      >{{ 'iss-wo-common.recurrence-schedule.date-range.end-date' | translate }}</tui-input-date>
      <ng-template issFormFieldError let-errors>
        <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
        <ng-container *ngIf="errors.minDate">{{ 'iss-wo-common.error.min-date'| translate: { minDate: errors.minDate | date }
        }}</ng-container>
      </ng-template>
    </iss-form-field>
  </div>
</div>
